var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-button-wrapper"},[_c('md-button',{staticClass:"md-button md-icon-button",on:{"click":function($event){return _vm.goToAssignedCreate()}}},[_c('md-icon',[_vm._v("person_add_alt_1")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }